import { asyncConnect } from 'react-async-client';
import { prop } from 'ramda';

import {
    setProjectMassListFilters,
    setProjectMassListSort,
    setProjectMassListPagination,
    setProjectMassListColumnWidth
} from 'actions/projectMassActions';
import { getUser } from 'actions/asyncActions';
import { withRouteOptions } from 'components/hocs/withRouteOptions';
import { fullAutoOptions } from 'constants/asyncClient';
import { defaultProjectMassColumns } from 'constants/defaultColumns';
import getProjectMassTableTemplate from './cellTemplates/projectMassTableTemplates';
import { getProjectMassList, getProjectMassListSettings } from 'actions/asyncActions';
import ProjectList from 'components/views/projectList/ProjectList';

const tableConfig = {
    defaultColumns: defaultProjectMassColumns,
    getTemplate: getProjectMassTableTemplate,
    headerTranslatePrefix: 'project.headers.'
};

const stateToProps = state => ({
    ...state.table.projectMass,
    tableConfig,
    headerTitle: '',
    user: getUser.selectData(state),
});

const dispatchToProps = {
    setPagination: setProjectMassListPagination,
    setSort: setProjectMassListSort,
    setFilters: setProjectMassListFilters,
    setColumnWidth: setProjectMassListColumnWidth
};

const ProjectMassListView = asyncConnect({
    getSettings: getProjectMassListSettings.withOptions({ dispatchOnMount: true }),
}, stateToProps, dispatchToProps)(
    asyncConnect({
        getList: getProjectMassList
            .withPayload(({ match: { params: { id } }, user }) => ({ id: id || prop('id', user) }))
            .withOptions(fullAutoOptions)
    })(
        withRouteOptions(ProjectList, 'menu.projectMass')
    )
);

export default ProjectMassListView;
